import { createApi } from "@reduxjs/toolkit/query/react";

import { REQUEST_METHODS } from "@/constants/global-constants";
import { ISubContractor } from "@/interfaces/subcontractor.interface";
import { BaseWithAuth, getWorkspace } from "@/utils/helpers";

export const subContractorApi = createApi({
  reducerPath: "subcontractorApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["subcontractor"],
  endpoints: (builder) => ({
    // get list of subcontractor
    getSubContractorList: builder.query<
      GeneralResponse<ISubContractor[]>,
      Partial<{ status: string; filter?: string }>
    >({
      query: ({ status, filter }) =>
        `/superadmin/workforce/subcontractor${status ? `?status=${status}` : ""}${filter ? filter : ""}`,
      providesTags: ["subcontractor"],
    }),

    // list of subconstractor according to the  workspace
    getSubContractorByWS: builder.query<
      GeneralResponse<ISubContractor[]>,
      Partial<{ status: string; filter?: string }>
    >({
      query: ({ status, filter }) =>
        `workspace/${getWorkspace()}/workforce/subcontractor${status ? `?status=${status}` : ""}${filter ? filter : ""}`,
      providesTags: ["subcontractor"],
    }),

    // get single subconstractor
    getSingleSubContractorByWs: builder.query<
      ISubContractor,
      { userId: string }
    >({
      query: ({ userId }) =>
        `workspace/${getWorkspace()}/workforce/subcontractor/${userId}`,
      providesTags: ["subcontractor"],
      transformResponse: (response: APIResponse<ISubContractor>) =>
        response?.data,
    }),

    //Update or delete subcontractor
    alterSubContractorByWs: builder.mutation<
      object,
      Partial<{
        data: object;
        userId: string;
        method?: string;
      }>
    >({
      query: ({ data, userId, method }) => ({
        url: `workspace/${getWorkspace()}/workforce/subcontractor/${userId ? userId : "ss"}`,
        method: method?.toUpperCase() || REQUEST_METHODS.PUT,
        body: data,
      }),
      invalidatesTags: ["subcontractor"],
    }),

    //Add subcontractor
    addSubContractorByWs: builder.mutation<object, Partial<{ data: object }>>({
      query: ({ data }) => ({
        url: `workspace/${getWorkspace()}/workforce/subcontractor`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["subcontractor"],
    }),

    //toggle status of subcontractor
    toggleSubContractorStatus: builder.mutation<
      unknown,
      { userId: string; status: string }
    >({
      query: ({ userId, status }) => ({
        url: `/workspace/${getWorkspace()}/workforce/subcontractor/${userId}/${status}`,
        method: "POST",
      }),
      invalidatesTags: ["subcontractor"],
    }),
  }),
});

export const {
  useAddSubContractorByWsMutation,
  useAlterSubContractorByWsMutation,
  useGetSingleSubContractorByWsQuery,
  useGetSubContractorByWSQuery,
  useGetSubContractorListQuery,
  useToggleSubContractorStatusMutation,
} = subContractorApi;
